import React, { useState } from 'react';
import { Button } from 'components';
import { Props } from 'types/modals';
import Base from '../../base';

const EditReferralModal = ({ closing, onClose, params }: Props) => {
  const [employeeId, setEmployeeId] = useState(params?.currentValue || '');

  const handleSubmit = () => {
    if (employeeId && employeeId.trim() !== '') {
      onClose(employeeId);
    } else {
      onClose(null);
    }
  };

  const handleCancel = () => {
    onClose(false);
  };

  const handleOverlayClose = () => {
    onClose(false);
  };

  return (
    <Base
      header="Edit Referral"
      closing={closing}
      onClose={handleOverlayClose}
      size="md"
      footer={
        <>
          <Button text="Cancel" variant="secondary" onClick={handleCancel} />
          <Button text="Save" onClick={handleSubmit} />
        </>
      }
    >
      <div style={{ padding: '20px 0' }}>
        <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500' }}>
          Enter the employee ID who referred this person:
        </label>
        <input
          type="number"
          value={employeeId}
          onChange={e => setEmployeeId(e.target.value)}
          placeholder="Enter employee ID"
          style={{
            width: '100%',
            padding: '8px 12px',
            border: '1px solid #C9C9C9',
            borderRadius: '6px',
            fontSize: '14px'
          }}
        />
      </div>
    </Base>
  );
};

export default EditReferralModal;
